module.exports = __webpack_public_path__ + "4286d72dc6dc632c45c8afa0953b1264.summer.svg";